import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import type { PaginationOptions, SwiperOptions } from 'swiper/types';
import { selectors } from './init.js';

const hasTilesLayout = (container: HTMLElement) => container.classList.contains('swiper');

export const initSlider = () => {
	document.querySelectorAll<HTMLElement>(`${selectors.locationSlider}`).forEach((container) => {
		const category = container.getAttribute('data-cat');
		const pagination: PaginationOptions = {
			el: `.swiper-pagination-${category}`,
			type: 'bullets',
			clickable: true,
		};
		const parameters: SwiperOptions = {
			modules: [Navigation, Pagination],
			loop: true,
			slidesPerView: hasTilesLayout(container) ? 1.25 : 1,
			spaceBetween: hasTilesLayout(container) ? 32 : 0,
			navigation: {
				nextEl: container.querySelector<HTMLButtonElement>(selectors.sliderBtnNext),
				prevEl: container.querySelector<HTMLButtonElement>(selectors.sliderBtnPrev),
			},
			pagination,
		};

		if (hasTilesLayout(container)) {
			pagination.dynamicBullets = true;
			parameters.breakpoints = {
				1000: {
					pagination: {
						dynamicBullets: false,
					},
					slidesPerView: 3.25,
					slidesPerGroup: 3,
				},
				1200: {
					pagination: {
						dynamicBullets: false,
					},
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
			};
		}

		new Swiper(container, parameters);
	});
};
